import * as React from 'react';

import { Skeleton } from 'antd';
import { Text } from 'farmhub-ui-core';

import { getDummyArray } from 'utils/function';

import ExpandTable from '../ExpandTable';
import { CTable, WrapperAbsolute } from './styles';

interface GroupProductTableProps {
  order: any;
  isLoading: boolean;
  columnsVisible?: {
    [column: string]: boolean;
  };
  informationVisible?: any;
}

const GroupProductTable = ({
  order,
  isLoading,
  columnsVisible,
  informationVisible,
}: GroupProductTableProps): JSX.Element => {
  const genColumns = React.useMemo(
    () => [
      {
        width: 30,
        title: (
          <Text
            color="black"
            size="xxs"
            styles={{ whiteSpace: 'nowrap' }}
            weight="extraBold"
          >
            STT
          </Text>
        ),
        key: 'order',
        align: 'center',
        render: (_: any, record: any, index: number) => {
          return {
            children: <></>,
            props: {
              className: 'hide-column-table',
            },
          };
        },
      },
      {
        title: (
          <Text color="black" weight="extraBold">
            Tên hàng hóa
          </Text>
        ),
        key: 'name',
        render: (product: any, record: any) => {
          return {
            children: informationVisible?.Category ? (
              <>
                <WrapperAbsolute>
                  <Text
                    color="black"
                    lineNumber={1}
                    size="xxs"
                    styles={{
                      width: '100%',
                      display: 'block',
                      whiteSpace: 'nowrap !important',
                    }}
                    weight="bold"
                  >
                    {record.name}
                  </Text>
                </WrapperAbsolute>
                <Text
                  color="black"
                  lineNumber={1}
                  size="xxs"
                  styles={{ whiteSpace: 'nowrap !important' }}
                  weight="bold"
                >
                  .
                </Text>
              </>
            ) : (
              <></>
            ),
            props: {
              className: 'merge-column-table hide-column-table',
            },
          };
        },
      },
      ...(columnsVisible?.SKUCode
        ? [
            {
              align: 'center',
              width: '10%',
              title: (
                <Text color="black" size="xxs" weight="extraBold">
                  Mã SKU
                </Text>
              ),
              dataIndex: 'product',
              key: 'sku',
              render: (product: any, record: any) => {
                return {
                  children: <></>,
                  props: {
                    className: 'hide-column-table',
                  },
                };
              },
            },
          ]
        : []),
      {
        align: 'center',
        width: '9%',
        title: (
          <Text color="black" size="xxs" weight="extraBold">
            ĐVT
          </Text>
        ),
        dataIndex: 'product',
        key: 'unit',
        render: (product: any, record: any) => {
          return {
            children: <></>,
            props: {
              className: 'hide-column-table',
            },
          };
        },
      },
      {
        align: 'center',
        width: '8%',
        title: (
          <Text color="black" size="xxs" weight="extraBold">
            Số lượng
          </Text>
        ),
        dataIndex: 'quantity',
        key: 'quantity',
        render: (quantity: number) => {
          return {
            children: <></>,
            props: {
              className: 'hide-column-table',
            },
          };
        },
      },
      ...(columnsVisible?.RetailPrice
        ? [
            {
              align: 'center',
              width: '11%',
              title: (
                <Text color="black" size="xxs" weight="extraBold">
                  Đơn giá lẻ
                </Text>
              ),
              dataIndex: 'product',
              key: 'retailPrice',
              render: (product: any, record: any) => {
                return {
                  children: <></>,
                  props: {
                    className: 'hide-column-table',
                  },
                };
              },
            },
          ]
        : []),
      ...(columnsVisible?.RetailUnit
        ? [
            {
              align: 'center',
              width: '10%',
              title: (
                <Text color="black" size="xxs" weight="extraBold">
                  ĐVT lẻ
                </Text>
              ),
              dataIndex: 'product',
              key: 'retailUnit',
              render: (product: any, record: any) => {
                return {
                  children: <></>,
                  props: {
                    className: 'hide-column-table',
                  },
                };
              },
            },
          ]
        : []),

      {
        width: '11%',
        align: 'right',
        title: (
          <Text color="black" size="xxs" weight="extraBold">
            Đơn giá mua
          </Text>
        ),
        key: 'price',
        render: (record: any) => {
          return {
            children: <></>,
            props: {
              className: 'hide-column-table',
            },
          };
        },
      },
      {
        width: '11%',
        align: 'right',
        title: (
          <Text color="black" size="xxs" weight="extraBold">
            Tiền hàng
          </Text>
        ),
        key: 'originPrice',
        render: (record: any) => {
          return {
            children: <></>,
            props: {
              className:
                columnsVisible?.PromotionPrice || columnsVisible?.TotalPrice
                  ? 'hide-column-table'
                  : '',
            },
          };
        },
      },
      ...(columnsVisible?.PromotionPrice
        ? [
            {
              width: '11%',
              align: 'right',
              title: (
                <Text color="black" size="xxs" weight="extraBold">
                  Tiền KM
                </Text>
              ),
              key: 'promotionPrice',
              render: (record: any) => {
                return {
                  children: <></>,
                  props: {
                    className: columnsVisible?.TotalPrice
                      ? 'hide-column-table'
                      : '',
                  },
                };
              },
            },
          ]
        : []),
      ...(columnsVisible?.SupplierNote || columnsVisible?.CustomerNote
        ? [
            {
              align: 'left',
              width: '14%',
              title: (
                <Text color="black" size="xxs" weight="extraBold">
                  Ghi chú
                </Text>
              ),
              dataIndex: 'product',
              key: 'retailPrice',
              render: (product: any, record: any) => {
                return {
                  children: <></>,
                  props: {
                    className: 'hide-column-table',
                  },
                };
              },
            },
          ]
        : []),
      ...(columnsVisible?.TotalPrice
        ? [
            {
              width: '12%',
              align: 'right',
              title: (
                <Text color="black" size="xxs" weight="extraBold">
                  Thành tiền
                </Text>
              ),
              key: 'totalPrice',
              render: (record: any) => {
                return {
                  children: <></>,
                };
              },
            },
          ]
        : []),
    ],
    [columnsVisible, informationVisible]
  );

  return isLoading ? (
    <></>
  ) : (
    <CTable
      bordered
      columns={isLoading ? columnsSkeleton : genColumns}
      dataSource={isLoading ? getDummyArray(10) : order?.entitySubCategories}
      expandable={{
        expandedRowRender: (record: any) =>
          isLoading ? (
            <></>
          ) : (
            <ExpandTable
              columnsVisible={columnsVisible}
              isLoading={isLoading}
              order={order}
              orderItems={record.orderItems}
            />
          ),

        expandIconColumnIndex: -1,
        defaultExpandAllRows: true,
        expandRowByClick: false,
        showExpandColumn: false,
        expandIcon: null,
        indentSize: 0,
      }}
      hideLevel0={!informationVisible?.Category}
      isLoading={isLoading}
      locale={{
        emptyText: (
          <Text color="black">Hiện tại không có sản phẩm thống kê</Text>
        ),
      }}
      pagination={false}
      rowKey="index"
    />
  );
};

export default GroupProductTable;

const columnsSkeleton: Array<any> = [
  {
    width: '6%',
    title: (
      <Skeleton.Input
        size="small"
        style={{ width: '25px', alignItems: 'center' }}
      />
    ),
    key: 'order',
    render: () => (
      <Skeleton.Input
        size="small"
        style={{ width: '25px', alignItems: 'center' }}
      />
    ),
  },
  {
    width: '24%',
    title: (
      <Skeleton.Input
        size="small"
        style={{ width: '160px', alignItems: 'center' }}
      />
    ),
    key: 'product',
    render: () => (
      <Skeleton.Input
        size="small"
        style={{ width: '160px', alignItems: 'center' }}
      />
    ),
  },
  {
    align: 'center',
    width: '14%',
    title: (
      <Skeleton.Input
        size="small"
        style={{ width: '100px', alignItems: 'center' }}
      />
    ),
    key: 'customerQuantity',
    render: () => (
      <Skeleton.Input
        size="small"
        style={{ width: '100px', alignItems: 'center' }}
      />
    ),
  },
  {
    align: 'center',
    width: '14%',
    title: (
      <Skeleton.Input
        size="small"
        style={{ width: '100px', alignItems: 'center' }}
      />
    ),
    key: 'supplierQuantity',
    render: () => (
      <Skeleton.Input
        size="small"
        style={{ width: '100px', alignItems: 'center' }}
      />
    ),
  },
  {
    align: 'center',
    width: '14%',
    title: (
      <Skeleton.Input
        size="small"
        style={{ width: '100px', alignItems: 'center' }}
      />
    ),
    key: 'supplierDeliveredQuantity',
    render: () => (
      <Skeleton.Input
        size="small"
        style={{ width: '100px', alignItems: 'center' }}
      />
    ),
  },
  {
    align: 'center',
    width: '14%',
    title: (
      <Skeleton.Input
        size="small"
        style={{ width: '100px', alignItems: 'center' }}
      />
    ),
    key: 'customerReceivedQuantity',
    render: () => (
      <Skeleton.Input
        size="small"
        style={{ width: '100px', alignItems: 'center' }}
      />
    ),
  },
  {
    width: '20%',
    title: (
      <Skeleton.Input
        size="small"
        style={{ width: '100px', alignItems: 'center' }}
      />
    ),
    key: 'price',
    render: () => (
      <Skeleton.Input
        size="small"
        style={{ width: '100px', alignItems: 'center' }}
      />
    ),
  },
];
